(function($, GLOBALS) {
	// selectTable class, used for converting HTML selects into tabular UIs
	(function($, settings) {
		var instance = 0, instances = [], Class;

		Class = function($select, settings) {
			var my, cls;

			cls = {
				populate: function() {
					my.parse(arguments[0], function(data, headers) {
						my.populate(data, headers);
					});
					return this;
				},

				fetch: function() {
					my.fetch.apply(this, arguments);
					return this;
				}
			};

			my = {
				enable: function() {
					if ($select.data("wsselecttable-active")) {
						return $shell;
					}

					settings = $.extend({
						'classes': {
							'list': 'table-list',
							'column': 'column',
							'selected': 'selected'
						},
						'selectors': {
							'list_item': 'tbody > tr'
						},
						'select': {
							'column_split': ';'
						},
						'endpoint': {
							'uri': $select.data("endpoint")
						}
					}, settings || {});

					my.createUI();

					$select.data("wsselecttable-active", true);
				},

				eventRegister: function(id) {
					return function(event) {
						my.event.apply(this, [event, id]);
					};
				},

				event: function(event, id) {
					if (id === "list_item") {
						my.select($(this).prevAll().length);
					}
				},

				createUI: function() {
					my.ui = {
						'$list': $("<table>", {
							'class': settings.classes.list
						}),
						'$body': $("<tbody>").css({
							'overflow': 'auto'
						}),
						'$head': $("<thead>")
					};

					$select.before(my.ui.$list.append(
						my.ui.$head,
						my.ui.$body
					)).hide();

					my.status = {
						'selected': -1
					};

					my.parse(null, function(data, headers) {
						my.data = data;
						my.headers = headers;
						my.populate(my.data, my.headers);
						my.select();

						// bind events
						my.ui.$list.on("click", settings.selectors.list_item, my.eventRegister("list_item"));
					});
				},

				parse: function(data, after) {
					// populate the list with either the passed data or the contents of the original select
					var $item, a, b;

					if (!data) {
						data = [];

						if ((headers = $select.data("column-headers"))) {
							headers = headers.split(";");
						}

						$select.find("option").each(function() {
							var a, $this = $(this), columns, item;

							item = {
								'value': $this.attr("value") || $this.text(),
								'label': []
							};

							if (!(columns = $this.text().split(settings.select.column_split)).length) {
								columns = [$this.text()];
							}

							for (a = 0; a < columns.length; a += 1) {
								item.label.push($.trim(columns[a]));
							}

							data.push(item);
						});
					} else {
						data = data.items;
						headers = data.headers;

						my.populateSelect(data);
					}

					if (typeof after === "function") {
						after.apply($select, [data, headers]);
					}
				},

				// fetch new data from the source
				fetch: function(after, params) {
					if (settings.endpoint.uri) {
						$.ajax(settings.endpoint.uri, {
							'data': params || {},
							'type': 'GET',
							'complete': function() {
								if (typeof after === "function") {
									after.apply($select, arguments);
								}
							}
						});
					}
				},

				formatNumber: function(value) {
					return value;
				},

				populate: function(data, headers) {
					my.ui.$body.empty();

					for (a = 0; a < data.length; a += 1) {
						$item = $("<tr>");
						data[a].label[1] = $.trim(my.formatNumber(data[a].label[1]));

						for (b = 0; b < data[a].label.length; b += 1) {
							$item.append(
								$("<td>", {
									'class': settings.classes.column + (b == 1 ? ' nowrap' : '')
								}).html(data[a].label[b])
							);
						}

						my.ui.$body.append($item);
					}

					if (headers) {
						my.ui.$head.empty();

						for (a = 0; a < headers.length; a += 1) {
							my.ui.$head.append(
								$("<th>").html(headers[a])
							);
						}
					}

					my.adjust();
				},

				populateSelect: function(data) {
					var a;

					$select.empty();

					for (a = 0; a < data.length; a += 1) {
						$select.append(
							$("<option>", {
								'value': data[a].value
							}).html(data[a].label.join(settings.select.column_split))
						);
					}
				},

				select: function(index) {
					if (index === undefined) {
						index = $select[0].selectedIndex;
					}

					if (my.status.selected !== -1) {
						my.ui.$body.children().eq(my.status.selected).removeClass(settings.classes.selected);
					}

					if (index !== -1) {
						my.ui.$body.children().eq(index).addClass(settings.classes.selected);
						my.status.selected = index;
					}

					$select[0].selectedIndex = index;
				},

				// scan tds to get widths and re-calculate for table's width
				adjust: function() {
					var $tds, table_width, td_widths;

					table_width = my.ui.$list.width();
					td_widths = 0;

					$tds = my.ui.$list.find("tr:first-child > td");
					$ths = my.ui.$list.find("thead > th");

					// get total TD widths
					$tds.each(function(index) {
						td_widths += $(this).outerWidth();
					});

					// adjust TDs to correct table width
					$tds.each(function(index) {
						var $this = $(this), width;
						width = $this.outerWidth();
						width = ((width / td_widths) * 100) * (table_width / 100);

						$this.css({
							'width': width + 'px'
						});
					});

					// adjust THs after table layout is concreted
					$tds.each(function(index) {
						if (index < ($tds.length - 1)) {
							$ths.eq(index).css({
								'width': $(this).outerWidth() + 'px'
							});
						}
					});
				}
			};

			my.enable();

			return cls;
		};

		$.fn.selectTable = function() {
			var a, $this, args;

			args = arguments;

			this.each(function() {
				$this = $(this);

				if ((a = $this.data("wsselecttable-instance")) === undefined) {
					$this.data("wsselecttable-instance", instance);
					a = instance;
					instance = instance + 1;
				}

				if (typeof args[0] === "string") {
					if (instances[a] && instances[a][args[0]]) {
						instances[a][args[0]].apply($this, Array.prototype.slice.call(args, [1]));
					} else {
						throw new Error("Instance must be created before methods are used");
					}
				} else {
					instances.push(new Class($this, args[0]));
				}
			});

			return this;
		};
	}($));

	/*
	 * The following code is for creating a slider and should be applied to generic forms
	 */
	$("input.slider.range").each(function() {
		var $this = $(this), ui, min, max;

		min = parseInt($this.attr("min"), 10);
		max = parseInt($this.attr("max"), 10);
		ui = {};

		ui.$label = $("label[for='" + $this.attr("id") + "']");

		if (ui.$label.length) {
			$this.replaceWith(
				ui.$slider = $("<div>", {
					'id': $this.attr("id") + '-slider'
				}).slider({
					'range': true,
					'min': min,
					'max': max,
					'values': [min, max],
				}).on("slide", function(event, data) {
					ui.$max.text(GLOBALS.currency_symbol + data.values[1].toFormatted(0,window.GLOBALS.thousands_seperator,window.GLOBALS.decimal_seperator)+GLOBALS.after_currency_symbol);
					ui.$min.text(GLOBALS.currency_symbol + data.values[0].toFormatted(0,window.GLOBALS.thousands_seperator,window.GLOBALS.decimal_seperator)+GLOBALS.after_currency_symbol);
				})
			);

			ui.$slider.wrap(
				$("<div>", {
					'class': 'ui-slider-wrapper'
				})
			);

			ui.$label.html(
				$("<span>", {
					'class': 'label'
				}).html(ui.$label.html())
			).prepend(
				ui.$max = $("<span>", {
					'class': 'max'
				}).text(GLOBALS.currency_symbol + max.toFormatted(0,window.GLOBALS.thousands_seperator,window.GLOBALS.decimal_seperator) + GLOBALS.after_currency_symbol)
			).prepend(
				ui.$min = $("<span>", {
					'class': 'min'
				}).text(GLOBALS.currency_symbol + min.toFormatted(0,window.GLOBALS.thousands_seperator,window.GLOBALS.decimal_seperator) + GLOBALS.after_currency_symbol)
			).addClass("slider-label range");
		}
	});


	/*
	 * The following code is specific to the 'start a project' form, but should be integrated into
	 * the generalised form logic within global.js
	 */
	$(".select-table").selectTable();

	$("#project-funding-slider").on("slidechange", function(event, ui) {
		var $this = $(this), $form;

		$form = $this.closest("form");
		$form.find("input[name='funding_from']").val(ui.values[0]);
		$form.find("input[name='funding_to']").val(ui.values[1]);
		$("#project-country").trigger("change");
	});

	$("#project-country").bind("change", function(event) {
		// executed when the project country select changes - update the school list
		var $this = $(this), $form, form_data, data;

		$form = $this.closest("form");
		form_data = $form.serializeObject();
		data = {
			'from': form_data.funding_from,
			'to': form_data.funding_to
		};

		if (form_data['project_country']) {
			data.country = [form_data['project_country']];
		}

		if (data.country || (data.from && data.to)) {
			$("#project-school_id.select-table").selectTable("fetch", function(xhr, status) {
				var a, json, data;

				if (status === "success" &&
					(json = xhr.responseJSON)) {
					// prep data for selectTable populate method
					data = {
						'headers': ['School name', 'Amount', 'Children'],
						'items': []
					};

					for (a = 0; a < json.schools.length; a += 1) {
						data.items.push({
							'value': json.schools[a].id,
							'label': [json.schools[a].title, json.schools[a].fund_cost, json.schools[a].enrollment]
						});
					}

					this.selectTable("populate", data);
				}
			}, data);
		}
	});
	/*
	 * END 'start a project' form code
	 */
}(window.jQuery, window.GLOBALS));
